import React, { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { beginTransaction } from '../../redux/actions/transaction'
import trackGa from '../../analytics'
import styles from './SubscriptionPackage.module.css'
import danaLogo from '../../assets/dana-logo.svg'

const SubscriptionPackage = ({
  id,
  name,
  duration,
  durationType,
  price,
  subscriptions,
  gateway,
  ...otherProps
}) => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth.user)
  const [retry, setRetry] = useState(false)

  const planPrice = useMemo(() => {
    const formatPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return otherProps.currency + ' ' + formatPrice
  }, [otherProps.currency, price])

  const planDuration = useMemo(() => {
    if (+duration > 0) {
      return `Valid for ${duration} ${durationType}${+duration > 1 ? 's': ''}`
    }
  }, [duration, durationType])

  const renderPayments = (gateway) => {
    if (gateway !== 'telco') return ''

    const telcos = {
      'telco-isat': 'Indosat',
      'telco-hutch': '3',
      'telco-smart': 'Smartfren',
      'telco-tsel': 'Telkomsel',
      'telco-axis': 'Axis',
      'telco-xl': 'XL'
    }

    return Object.entries(otherProps.payments)
      .reduce((gws, [key, value]) => {
        let name
        name = telcos[key]
        if (name && value.description) 
          gws.push({ name, description: value.description })

        return gws
      }, [])
      .map(payment => 
        <li key={payment.name}>
          <strong>{payment.name}</strong> <span className={styles['plan-description']}>{payment.description}</span>
        </li>)
  }

  // const isSubscribed = useMemo(() => {
  //   const packageIds = subscriptions.map(subscription => subscription.packageId)   
  //   try {
  //     return packageIds.includes(id)
  //   } catch {
  //     return false
  //   }
  // }, [subscriptions, id])

  const onPurchase = async () => {
    // do purchase logic
    if (gateway === 'dana') {
      const paramsGA = {
        packageID: id
      }
      trackGa('Subscription', 'selectPackage', paramsGA, user)
      try {
        const params = { type: 'dana-balance', packageId: id }
        let checkoutUrl

        let result = await dispatch(beginTransaction(params))
        const transaction = result.data[0]
        checkoutUrl = result.meta.checkoutUrl

        // if transaction status is cancelled, there is possibility that
        // previously there is an expired payment attempt, so 
        // we will retry once to refresh the expired attempt
        if (!checkoutUrl && transaction.status === 'cancelled' && !retry) {
          setRetry(true)
          result = await dispatch(beginTransaction(params))
          checkoutUrl = result.meta.checkoutUrl
        }

        window.location.href = checkoutUrl
      } catch (err) {
        console.log(err)
      }
    }  
  }

  return (
    <div className={styles['plan-wrapper']}>
      <p className={styles['plan-name']} title={name}>
        {name}
      </p>
      <div className={styles['plan-info']}>
        {gateway === 'dana' ? <img className={styles['payment-logo']} alt='dana-logo' src={danaLogo} />  :''}
        {gateway !== 'telco' ? <p className={styles['plan-price']}>{planPrice}</p> : ''}
        <p className={styles['plan-duration']}>{planDuration}</p>
        <ul>
          {renderPayments(gateway)}
        </ul>
        {gateway !== 'telco' ? <button onClick={onPurchase}>Purchase</button> : ''}        
      </div>
    </div>
  )
}

export default SubscriptionPackage
